/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

import {
  SINGLE_REVIEW_CLEAN_REQUEST,
  REVIEW_CLEAN_REQUEST,
  REVIEW_ADD_REQUEST,
  REVIEW_ADD_REQUEST_SUCCESS,
  REVIEW_ADD_REQUEST_FAILURE,
  REVIEW_FETCH_REQUEST,
  REVIEW_FETCH_REQUEST_SUCCESS,
  REVIEW_FETCH_REQUEST_FAILURE,
  SINGLE_REVIEW_PROCESS_REQUEST,
  SINGLE_REVIEW_PROCESS_REQUEST_SUCCESS,
  SINGLE_REVIEW_PROCESS_REQUEST_FAILURE,
  REVIEW_REASSIGN_REQUEST,
  REVIEW_REASSIGN_REQUEST_SUCCESS,
  REVIEW_REASSIGN_REQUEST_FAILURE,
} from './types';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
  singlePayload: [],
  singleLoading: false,
  singleErrors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const reviewReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case REVIEW_REASSIGN_REQUEST:
    case REVIEW_ADD_REQUEST:
    case REVIEW_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case REVIEW_REASSIGN_REQUEST_SUCCESS:
    case REVIEW_ADD_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });

    case REVIEW_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.limit,
          total: action.data.totalRecords,
          totalPage:
            Math.round(action.data.totalRecords / action.data.limit) +
            (Math.abs(action.data.totalRecords / action.data.limit) >
            Math.round(action.data.totalRecords / action.data.limit)
              ? 1
              : 0),
          showSizeChanger: true,
        },
      });

    case REVIEW_REASSIGN_REQUEST_FAILURE:
    case REVIEW_ADD_REQUEST_FAILURE:
    case REVIEW_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case SINGLE_REVIEW_PROCESS_REQUEST:
      return Object.assign({}, state, {
        singleLoading: true,
      });

    case SINGLE_REVIEW_PROCESS_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        singleLoading: false,
        singlePayload: action.data,
        singleErrors: {},
      });
    case SINGLE_REVIEW_PROCESS_REQUEST_FAILURE:
      return Object.assign({}, state, {
        singleLoading: false,
        singleErrors: action.error,
      });

    case SINGLE_REVIEW_CLEAN_REQUEST:
      return Object.assign({}, state, {
        singlePayload: [],
        singleLoading: false,
        singleErrors: {},
      });

    case REVIEW_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
        singlePayload: [],
        singleLoading: false,
        singleErrors: {},
      });

    default:
      return state;
  }
};

export default reviewReducer;
